import { ITEMS_PER_PAGE, SortOrder } from "constants/general";

export const trackerFields = { created: "_created" };


export const TRACKER_GENERAL_FILTER = {
    offset: 0,
    limit: ITEMS_PER_PAGE,
    sort_direction: SortOrder.desc,
    sort_field: trackerFields.created,
    storage_type_code: "HOT"
};

export const TRACKER_FILTER_OPTIONS = {
    ...TRACKER_GENERAL_FILTER,
    is_initial: true,
    enable_wildcards: false,
    object_structure_property_value_enable_wildcards: false
};

export const TRACKER_DEF_FILTER = {
    ...TRACKER_GENERAL_FILTER,
};

export const TRACKER_STATUS = {
    DONE: "DONE",
    ERROR: "ERROR",
    IN_QUEUE: "IN_QUEUE",
    SKIPPED: "SKIPPED",
    WARNING: "WARNING"
};

export const POSSIBLE_FILTER_PARAMETERS = {
    "storage_type_code": {
        "type": "string",
        "is_array": false
    },
    "browser_source_type_code": {
        "type": "string",
        "is_array": false
    },
    "receiver_code": {
        "type": "string",
        "is_array": false
    },
    "brand_code": {
        "type": "string",
        "is_array": false
    },
    "branch_codes": {
        "type": "string",
        "is_array": true
    },
    "source_code": {
        "type": "string",
        "is_array": false
    },
    "status_code": {
        "type": "string",
        "is_array": false
    },
    "status_type_code": {
        "type": "string",
        "is_array": false
    },
    "keyword": {
        "type": "string",
        "is_array": false
    },
    "template_code": {
        "type": "string",
        "is_array": false
    },
    "must_have_message": {
        "type": "string",
        "is_array": false
    },
    "must_not_have_messages": {
        "type": "string",
        "is_array": true
    },
    "track_id": {
        "type": "string",
        "is_array": false
    },
    "parent_track_id": {
        "type": "string",
        "is_array": false
    },
    "initial_track_id": {
        "type": "string",
        "is_array": false
    },
    "batch_id": {
        "type": "string",
        "is_array": false
    },
    "url": {
        "type": "string",
        "is_array": false
    },
    "user_id": {
        "type": "integer",
        "is_array": false
    },
    "is_template_recognized": {
        "type": "boolean",
        "is_array": false
    },
    "is_sandbox_mode": {
        "type": "boolean",
        "is_array": false
    },
    "is_initial": {
        "type": "boolean",
        "is_array": false
    },
    "is_debug_mode": {
        "type": "boolean",
        "is_array": false
    },
    "has_retry_attempt": {
        "type": "boolean",
        "is_array": false
    },
    "has_message": {
        "type": "boolean",
        "is_array": false
    },
    "has_http_response": {
        "type": "boolean",
        "is_array": false
    },
    "enable_wildcards": {
        "type": "boolean",
        "is_array": false
    },
    "object_structure_property_value_enable_wildcards": {
        "type": "boolean",
        "is_array": false
    },
    "created": {
        "type": "datetime",
        "is_array": false
    },
    "created_at_initial_from": {
        "type": "datetime",
        "is_array": false
    },
    "created_at_initial_to": {
        "type": "datetime",
        "is_array": false
    },
    "limit": {
        "type": "integer",
        "is_array": false
    },
    "offset": {
        "type": "integer",
        "is_array": false
    },
    "sort_field": {
        "type": "string",
        "is_array": false
    },
    "sort_direction": {
        "type": "string",
        "is_array": false
    },
    "object_structure_code": {
        "type": "string",
        "is_array": false
    },
    "object_structure_property_code": {
        "type": "string",
        "is_array": false
    },
    "object_structure_property_value": {
        "type": "string",
        "is_array": false
    },
};
